<template>
  <!-- 投資型基本輸入：版型五　彈性繳VA -->
  <div>
    <div class="row mt_16"><div class="col create_title">規劃保費</div></div>
    <!-- 保費 -->
    <div class="form-group d-flex align-items-end mt_30">
      <!-- 第一年保費 -->
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center">
          <strong class="mr_4">第一年保費:</strong>
          <div class="position-relative">
            <div
              class="notice-top text-red"
              v-if="PRODUCT_FEATURE_DATA.face_prem_incr_unit != '0'"
            >
              {{
                `每次輸入需以${formatMethods(
                  PRODUCT_FEATURE_DATA.face_prem_incr_unit
                )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
              }}
            </div>
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('first_premium') }"
              :id="'first_premium'"
              :data-vv-name="'first_premium'"
              v-validate="`required|first_premium`"
              @input="
                numberHandler(productDataScope, 'first_premium', $event);
                resetPaymethod();
              "
              @blur="numberHandler(productDataScope, 'first_premium', $event)"
              :value="productDataScope.first_premium | formatMethods"
              :placeholder="
                prem_limit && prem_limit[6]
                  ? `${formatMethods(
                      converIncrUnit(prem_limit[6].prem_floor)
                    )}~${formatMethods(
                      converIncrUnit(prem_limit[6].prem_ceil)
                    )}`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
    </div>
    <!-- 第二年(含)以後保費 -->
    <div class="form-group d-flex align-items-center mt_20">
      <div class="d-flex mr_8">
        <strong style="line-height: 40px">第二年(含)以後保費:</strong>
      </div>
      <!-- 新增繳費方式 -->
      <div class="position-relative d-inline-block">
        <div class="notice-top" style="bottom: 52px">非必要欄位，可不輸入</div>
        <a
          class="btn btn-default"
          style="line-height: 20px; height: 44px"
          @click="addPayMethods()"
        >
          新增繳費方式
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
import moment from "moment";
export default {
  props: ["productDataScope", "mainIndex", "option"],
  mixins: [mf_Mixin],
  data() {
    return {
      prem_limit: [{}, {}, {}, {}],
      getINVAmtLimitTimer: null,
      insurer_actage: this.$store.getters.MfEditing.insurer.insured_birthday
        ? moment().diff(
            moment(this.$store.getters.MfEditing.insurer.insured_birthday),
            "years"
          )
        : this.$store.getters.MfEditing.insurer.insured_age,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productDataScope.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productDataScope.FEATURE_DATA.amt_unit);
      }
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
  },
  mounted() {
    this.init();
    this.productDataScope.pay_freq =
      this.productDataScope.FEATURE_DATA.pay_freq;
  },
  methods: {
    async addPayMethods() {
      const checkResult = await this.$validator.validateAll();
      if (!checkResult) {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      } else {
        this.productDataScope.first_premium_tmp =
          this.productDataScope.first_premium;
        this.productDataScope.dueage_tmp = this.productDataScope.dueage;
        this.$router.push("/mf/create/addPremium");
      }
    },
    init() {
      this.getINVLimitRanges();
    },
    async getINVLimitRanges() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let { prem_limit } = await this.$mfAPI.MFB1_0100__getINVLimitRanges({
        prod_id: this.nowProduct.prod_id,
        insured_actage: insured_actage,
        insured_age: this.MfEditing.insured.insured_age,
        insured_gender: this.MfEditing.insured.insured_gender,
      });
      this.prem_limit = prem_limit;
      this.initValidator();
    },
    initValidator() {
      Validator.extend(`first_premium`, {
        getMessage: "",
        validate: (value) => {
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          let ceil =
            this.prem_limit[6].prem_ceil <= 0
              ? Infinity
              : this.prem_limit[6].prem_ceil;

          return (
            intValue <= ceil &&
            intValue >= this.prem_limit[6].prem_floor &&
            intValue % incr_unit === 0
          );
        },
      });
    },
    converIncrUnit(number) {
      let face_prem_incr_unit =
        this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
          ? 1
          : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
      return Math.floor(number / face_prem_incr_unit) * face_prem_incr_unit;
    },
    async validateAll() {
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
    resetPaymethod() {
      if (this.productDataScope.paymethod) {
        // 沒有去使用新增繳費方式(paymethod)，但商品儲存時會產出paymethod={}，故多加此判斷
        if (this.productDataScope.paymethod !== "{}") {
          this.$mfNotice(
            "修改第一年保費,若有輸入的不定期保費將全部清除,是否仍要修改?",
            () => {
              this.productDataScope.paymethod = null;
              this.productDataScope.temp__paymethod = null;
            },
            true,
            () => {
              this.productDataScope.first_premium =
                this.productDataScope.first_premium_tmp;
              this.$validator.reset();
            },
            "確定清除"
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-right: 8px !important;
  line-height: 40px;
  white-space: nowrap;
}
</style>
